"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

// Extend Window interface for gtag
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
        if (pathname === "/") {
             setShowBanner(true);
        }
    } else if (consent === "accepted") {
       // If returning user has accepted, make sure to update consent
       if (typeof window !== "undefined" && window.gtag) {
           window.gtag("consent", "update", {
             ad_storage: "granted",
             ad_user_data: "granted",
             ad_personalization: "granted",
             analytics_storage: "granted",
           });
       }
    }
  }, [pathname]);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
    
    // Grant consent to Google
    if (typeof window !== "undefined" && window.gtag) {
      console.log("Granting full consent to Google...");
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    } else {
        console.warn("window.gtag not found during consent grant.");
    }
  };

  const handleDecline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setShowBanner(false);
    
    // Explicitly deny consent
    if (typeof window !== "undefined" && window.gtag) {
      console.log("Denying consent to Google...");
      window.gtag("consent", "update", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
      });
    }
  };
// ... rest of component stays same
  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-[350px] w-full bg-[#e4e2dd] border-[3px] border-[#1a1a1a] shadow-[4px_4px_0px_#1a1a1a] p-6 flex flex-col gap-4">
      <div className="flex justify-between items-start">
         <h3 className="pixel-font text-[1.2rem] leading-none">COOKIE CONSENT</h3>
         <button onClick={handleDecline} className="text-xl leading-none hover:opacity-50">&times;</button>
      </div>
      <p className="text-[0.9rem] leading-tight">
        We use cookies to analyze traffic and improve your experience. See our{" "}
        <Link href="/privacy" className="underline font-bold">Privacy Policy</Link>.
      </p>
      <div className="flex gap-4 mt-2">
        <button
          onClick={handleDecline}
          className="flex-1 py-2 text-sm border-[2px] border-[#1a1a1a] hover:bg-[#ccc] transition-colors font-bold uppercase"
        >
          Necessary
        </button>
        <button
          onClick={handleAccept}
          className="flex-1 py-2 text-sm bg-[#1a1a1a] text-[#e4e2dd] border-[2px] border-[#1a1a1a] hover:bg-black transition-colors font-bold uppercase"
        >
          Accept All
        </button>
      </div>
    </div>
  );
}
